import React, { Component } from 'react';
import { Header, Icon, Grid } from 'semantic-ui-react';
import { Col, Row } from 'reactstrap';
import Table from './TableComponent';
import moment from 'moment';
import { Services } from '../../Reports/Services';
import axios from 'axios';
import Loader from './../../../Global/Loader/index'




class ReportsDetailComponent extends Component {
  state = {
    handleBack: this.props.handleBack,
    item: this.props.item,
    viewReport: this.props.item.ViewReport,
    results: this.props.results,
    data: this.props.table,
    loaderMap: false,
    client: this.props.client ? this.props.client : ''

  }

  componentDidMount = () => {
    this.getDataTable();
  };


  getDataTable = () => {
    const { ViewReport, Filter } = this.state.item;
    const { client } = this.state;

    let arrayVacio = []
    let newVistaReport = ''

    let str = ViewReport.slice(7, ViewReport.toLowerCase().search('from'));
    let arr = str.split(',');
    let rett = {};
    arr.map(e => {
      let remov = e.split('"').join('');
      var ret;
      if (remov[0] === ' ') {
        ret = remov.slice(1, remov.length - 1);
        ret = ret.slice(0, ret.search(' '));
      } else {
        ret = remov.slice(0, remov.search(' '));
      }
      rett[ret] = '';
      return ret;
    });
    arrayVacio.push(rett)

    if (Filter) {
      newVistaReport = ViewReport + Filter + client
    }
    else {
      newVistaReport = ViewReport
    }

    let data = {
      vwt: newVistaReport
    }
    // console.log("data", data);
    axios.post(`${Services.GET_VISTA_REPORTES.path}reports/vwreport`, data).then((response) => {
      if (response.data.data.length === 0) {
        this.setState({ data: arrayVacio, results: 0, loaderMap: true, configRep: response.data.config });
      } else {
        this.setState({ data: response.data.data, results: response.data.data.length, loaderMap: true, configRep: response.data.config }, () => {
        });
      }
    }).catch((error) => {
      this.setState({ data: arrayVacio, results: 0 });
    });
  };

  render() {
    let { handleBack, item, data, results, loaderMap } = this.state;
    return (
      <>
        <Loader hidden={loaderMap}></Loader>

        <Header as='h3' className='_btnBack' onClick={handleBack}>
          <div className='link-containers d-flex flex-row align-items-center'>
            <Icon.Group size='large'>
              <Icon name='angle left' className='_btnBack' size='big' onClick={handleBack} />
            </Icon.Group>
            Back
          </div>
        </Header>
        <Col md={12} xl={12}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Col md={12} xl={12}>
                  <Row>
                    <Col md={12} xl={12} className='_titleDetailReport'>{item.Name}</Col>
                    <Col md={12} xl={12}>
                      <Row>

                        <Col md={4} xl={2}>
                          <Row>
                            <Col className='title_report_detail' md={12} xl={12}>Creation Date:</Col>
                            <Col style={{ color: "black" }} className='title_report_detail' md={12} xl={12}>{moment(item.CreationDate).format('YYYY-MM-DD')}</Col>
                          </Row>
                        </Col>

                        <Col md={8} xl={10}>
                          <Row>
                            <Col className='title_report_detail' md={12} xl={12}>Results:</Col>
                            <Col className='title_report_detail' md={12} xl={12}>{results}</Col>
                          </Row>
                        </Col>

                      </Row>
                    </Col>
                    <Col md={12} xl={12}>
                      <Row>
                        <Col>
                          <br />
                          <Row>
                            <Col className='title_report_detail' md={12} xl={12}>Description:</Col>
                            <Col style={{ color: "black" }} className='title_report_detail' md={12} xl={12}>{item.Description}</Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Grid.Column>

            </Grid.Row>

            {/* START OF TABLE */}
            <Grid.Row>
              <Grid.Column>
                <Table
                  data={data}
                  //  itemsByPage={this.props.itemsByPage}
                  info={
                    {
                      name: item.Name,
                      date: moment(new Date()).format('YYYY-MM-DD'),
                      results: this.state.results,
                      description: item.Description,
                      config: this.state.configRep ? this.state.configRep : {}
                    }
                  }
                />
              </Grid.Column>
            </Grid.Row>
            {/* END OF TABLE */}
          </Grid>
        </Col>
      </>
    );
  }
}

export default ReportsDetailComponent;